import {request} from "./request";

export function getSysDict(code) {
    return request({
        url: '/system/getSysDict',
        params: {
            code:code
        }
    })
}
